var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-btn',{attrs:{"text":_vm.$t('servicesystem.common_objects.commonterms.clear'),"icon":'mdi-backspace',"color":'error',"disabled":false,"textbtn":_vm.textbtn,"large":_vm.large,"small":_vm.small},on:{"Press":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }